module.exports = __webpack_public_path__ + "media/images/index/cloud-a9e32901d0788a00c4091c5d943f62ce.svg";